module.exports = __webpack_public_path__ + "static/media/icono-hamburguesa.d4fb5a9b.svg";